<template>
  <div class="about-page">
    <div class="uk-section">
      <div class="uk-container uk-container-large">
        <h2 class="about-title">{{ $t("message.About") }}</h2>
        <div class="about-copy__container">
          <p>{{ copy[0] }}</p>
          <p>{{ copy[1] }}</p>
        </div>
      </div>
    </div>

    <div class="uk-container uk-container-large">
      <h2 class="about-title about-sub-title">Contact</h2>
      <div class="about-copy__container">
        <p>{{ $t("message.Phone") }}: (416) 596 0833</p>
        <p>{{ $t("message.Email") }}: info@ccnctoronto.ca</p>
      </div>
    </div>

    <div class="uk-section">
      <div class="uk-container uk-container-large">
        <h2 class="about-title about-sub-title about-sub-partner">Partner Organizations</h2>
        <div class="about-partner-container">
          <img
            class="about-partner-image"
            v-for="(pImage, index) in partnerImages"
            :src="pImage"
            :key="index"
          />
        </div>
        <div class="about-funder-container">
          <img class="about-funder-image" :src="canadaImage" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const COPY = {
  en: [
    "In response to addressing the growing anti-Asian racism that has intensified amidst COVID-19, our organizations: the Chinese Canadian National Council - Toronto Chapter; Chinese Canadian National Council Social Justice; Chinese and Southeast Asian Legal Clinic; and, Civic Engagement Network - Society of Canada - have come together to create Fight COVID Racism, a website platform dedicated to tracking and reporting anti-Asian racism and xenophobia in Canada.",
    "This project aims to validate the spectrum of experiences felt across Asian Canadian communities and seeks to use the documentation to inform future efforts for collective action against anti-Asian racism and xenophobia."
  ],
  fr: [
    "Afin de répondre au racisme anti-asiatique croissant que ne cesse de s’intensifier pendant la COVID-19, nos organismes - le Conseil national des Sino-Canadiens - Section de Toronto; le Conseil national des Sino-Canadiens - Justice sociale; la Clinique juridique chinoise et asiatique du sud-est; et le Réseau d’engagement civique - Société du Canada - se sont unis pour créer « Combattre le racisme lié à la COVID », une plateforme web qui se consacre au suivi et au signalement du racisme et de la xénophobie anti-asiatiques au Canada.",
    "Ce projet vise à valider la gamme d’expériences vécues dans les communautés asiatique canadiennes, et utiliser la documentation afin de guider les actions entreprises collectivement contre le racisme et la xénophobie anti-asiatiques dans l’avenir"
  ],
  zhcn: [
    "为应对在新冠肺炎疫情中愈演愈烈的反亚裔种族主义，我们的组织:全加华人平权会多伦多分会;全加华人平权会社会正义；华越柬寮法律援助中心；公民参与网络—加拿大社会—共同创建了一个网站平台，致力于追踪和报导加拿大的反亚裔种族主义和仇外情绪。",
    "该项目旨在验证整个加拿大亚裔社区所感受到的各种经历，并试图利用该文献为今后针对反亚洲种族主义和仇外心理的集体行动提供信息。"
  ],
  zhtw: [
    "為應對在新冠肺炎疫情中愈演愈烈的反亞裔種族主義，我們的組織:全加華人平權會多倫多分會;全加華人平權會社會正義；華越柬寮法律援助中心；公民參與網絡—加拿大社會—共同創建了一個網站平台，致力於追踪和報導加拿大的反亞裔種族主義和仇外情緒。",
    "該項目旨在驗證整個加拿大亞裔社區所感受到的各種經歷，並試圖利用該文獻為今後針對反亞洲種族主義和仇外心理的集體行動提供信息。"
  ]
};

const PARTNER_IMAGES = [
  require("@/assets/images/partners/ccncto.png"),
  require("@/assets/images/partners/project1907.png")
];

export default {
  name: "AboutPage",
  computed: {
    copy() {
      return COPY[this.$i18n.locale];
    }
  },
  data() {
    return {
      partnerImages: PARTNER_IMAGES,
    };
  }
};
</script>
<style lang="css">
.about-page {
  height: 100%;
}

.about-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 50px;
}

.about-sub-title {
  font-size: 28px;
}

.about-copy__container {
  padding-left: 50px;
  padding-right: 50px;
}

.about-partner-image {
  height: 150px;
  width: auto;
}

.about-sub-partner {
  text-align: center;
}

.about-partner-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin-bottom: 100px;
}

.about-funder-container {
  display: flex;
  justify-content: center;
}

.about-funder-image {
  height: 100px;
  width: auto;
}

@media only screen and (max-width: 850px) {
  .about-copy__container {
    padding: 0;
  }
}
</style>
